export const phoneApp = {
  dialPhoneNumber(phoneNumber: string) {
    window.open('tel:' + phoneNumber);
  },

  openMap(address: string) {
    if (usePlatformStore().isIos) {
      if (useSettingsStore()._settings.defaultMap === MapSetting.apple) {
        window.open(`http://maps.apple.com/?address=${address}`);
      }

      if (useSettingsStore()._settings.defaultMap === MapSetting.google) {
        window.open(`https://www.google.com/maps/search/?api=1&query=${address}`);
      }
    } else {
      window.open(`https://www.google.com/maps/search/?api=1&query=${address}`);
    }
  },

  openMail(mail: string) {
    window.open('mailto:' + mail);
  },

  openWiki() {
    const wikiLink = 'https://www.sema-soft.com/de/insights/college';
    window.open(wikiLink);
  },

  openLink(link: string) {
    window.open(link);
  }
};
